<script>
import { notify } from '@/helpers/notify' 

export default {
  name: 'CreateModal',
  props:[
      "list"
  ],
  data() {
    return {
      form: {},
      ilList : [],
      bucakList:[],
      submitted: false,
    };
  },
    mounted() {
        this.setSelected({ id : 0},'il')
    },
    watch:{
        list(props){
            this.form = {...props}
        }
    },
    methods: {
        handleSubmit() {
            this.submitted = true;
        
            if(this.form.id)
                this.update();
            else
                this.create();

            this.$emit('loadItems');
           
            this.submitted = false;
        },
        async create(){
            await this.$http.post('/apartman/store', {...this.form,blok:this.blok})
                .then(resp => {
                this.form = {};
                return notify.success(resp.data.message)
                })
                .catch(error => error)
        },
        async update(){
            await this.$http.put('/apartman/' + this.form.id , this.form)
                .then(resp => {
                return notify.success(resp.data.message)
                })
                .catch(error => error)
        },
        async remove(id){
            await this.$http.delete('/apartman/' + id)
                .then(resp => {
                if(resp.data.code !==  100)  return notify.error(resp.data.message)
                return notify.success(resp.data.message)
                })
                .catch(error => error)
        },
        close(){
            this.$parent.$bvModal.hide('modal-scoped')
        },
        async setSelected(val,event){
            const object = event + 'List' 
            const { id } = val
            const response = await this.$http.post(`/address/${event}/${id}`)
            if(response.data.error) return;
            this[object] = response.data;
        },
    },
};
</script>  

<template>
    <b-modal id="modal-scoped" title="Apartman Ekle/Güncelle"  no-close-on-backdrop hide-footer>
        <form @submit.prevent="handleSubmit">
            <div class="row">
                <div class="col-12">
                    <div class="mb-3">
                        <label>Apartman İsmi</label>
                        <input type="input" class="form-control" v-model="form.name" />
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-6">
                    <div class="mb-3">
                        <label>İlçe</label>
                         <v-select
                            label="name" 
                            v-model="form.province"
                            :options="ilList" 
                            :reduce="country => country.id"
                            @option:selecting="setSelected($event,'bucak')"><span slot="no-options">Sonuç Bulunamadı</span>
                        </v-select>
                    </div>
                </div>
                <div class="col-6">
                    <div class="mb-3">
                        <label>Bölge</label>
                        <v-select 
                            label="name"  
                            v-model="form.quarter"                    
                            :options="bucakList" 
                            :reduce="country => country.id"><span slot="no-options">Sonuç Bulunamadı</span>
                        </v-select>
                    </div>
                </div>
            </div>
            
            <div class="row">
                <div class="col-12">
                    <div class="mb-3">
                        <label>Adres</label>
                        <input type="input" class="form-control" v-model="form.address" />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <div class="mb-3">
                        <label>Koordinat</label>
                        <input type="input" class="form-control"  v-model="form.coordinate"/>
                    </div>
                </div>
                <div class="col-6">
                    <div class="mb-3">
                        <label>Mac Adres</label>
                        <input type="input" class="form-control" v-model="form.mac" />
                    </div>
                </div>
            </div>
             <div class="row">
                <div class="col-6">
                    <div class="mb-3">
                        <label>Bina Kimlik Numarası</label>
                        <input type="input" class="form-control"  v-model="form.bina_no"/>
                    </div>
                </div>
            </div>
            <div class="d-flex justify-content-between mt-3">
                <div>
                    <b-button variant="danger"  v-if="form.id" @click="remove(form.id)">Sil</b-button>
                </div>
                <div>
                    <b-button variant="light" @click="close()">Vazgeç</b-button>
                    <b-button 
                        v-if="form.id"
                        type="submit" 
                        variant="warning" 
                        class="ms-1"
                        >Güncelle
                    </b-button>
                    <b-button 
                        v-else
                        type="submit" 
                        variant="success" 
                        class="ms-1"
                        >Oluştur
                    </b-button>
                </div>
            </div>
        </form>
    </b-modal>
</template>